import { render, staticRenderFns } from "./DialogComponent.vue?vue&type=template&id=22f5bbcc&"
import script from "./DialogComponent.vue?vue&type=script&lang=ts&"
export * from "./DialogComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports